export const isBottomArrowIsNotVisible = (index: number, dataLength: number) => {
  return index === dataLength - 1
}
